import * as yup from 'yup'

export const schema = yup.object().shape(
    {
        dataInicio: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((curr, orig) => (orig === '' ? null : curr))
            .when('dataFinal', (dataFinal, schema) => {
                const timeStemp = 86400000 * 90

                const check: boolean = dataFinal === ''
                const min = !check
                    ? new Date(dataFinal?.getTime() - timeStemp)
                    : ''

                return dataFinal && !check
                    ? schema
                          .min(
                              min,
                              'O intervalo deve ser de no  maximo 90 dias'
                          )
                          .max(
                              dataFinal,
                              'A Data Inicial não pode ser superior à data de final'
                          )
                    : schema
            })
            .nullable(),
        dataFinal: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((curr, orig) => (orig === '' ? null : curr))
            .when('dataInicio', (dataInicio, schema) => {
                const timeStemp = 86400000 * 90
                const check = dataInicio === ''

                const max = !check
                    ? new Date(dataInicio?.getTime() + timeStemp)
                    : ''
                return dataInicio && !check
                    ? schema
                          .min(
                              dataInicio,
                              'A Data Final não pode ser inferior à data de início'
                          )
                          .max(
                              max,
                              'O intervalo deve ser de no  maximo 90 dias'
                          )
                    : schema
            })
            .nullable(),

        detran: yup.string()
    },
    [['dataInicio', 'dataFinal']]
)
